export default __webpack_public_path__ + "static/media/Minted.7c661289.webp";